const NA = () => <div className="text-gray-500">N/A</div>;
export default NA;
